import React, { useEffect } from 'react';
import CalculatorTitleContent from './CalculatorTitleContent';
import { CalculatorContainer, Background, EstimatePrompt } from './styles';

const PriceCalculator = () => {
  useEffect(() => {
    if (typeof location === 'undefined') {
      return;
    }

    const script = document.createElement('script');

    if (!process.env.REACT_APP_PRICE_CALCULATOR_URL) {
      console.error('REACT_APP_PRICE_CALCULATOR_URL is undefined');
    } else script.src = process.env.REACT_APP_PRICE_CALCULATOR_URL;

    script.async = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);
  }, []);

  return (
    <Background>
      <EstimatePrompt size="xxlarge">Want an estimate?</EstimatePrompt>
      <CalculatorTitleContent title="Life insurance calculator" />
      <CalculatorContainer id="policygenius-price-calculator" data-color="#EB6424" />
    </Background>
  );
};

export default PriceCalculator;
